// Vendor
import {
  useBreakpoints,
  useWindowSize,
  watch,
  LAYOUT_BREAKPOINT,
} from "#imports";

// Types
import type { TNavigationState } from "../shared/types/navbar";

export default function useNavigation() {
  const breakpoints = useBreakpoints(LAYOUT_BREAKPOINT);

  const _resizeObserverRegistered = useState("_resizeObserverRegistered", () =>
    shallowRef(false),
  );

  const navigationState = useState<TNavigationState>(
    "layoutNavigation",
    () => ({
      openedNavigationDropDownId: null,
      mobileDrawerOpen: false,
    }),
  );

  const closeAll = () => {
    navigationState.value.mobileDrawerOpen = false;
    navigationState.value.openedNavigationDropDownId = null;
  };

  const closeMobileDrawer = () => {
    navigationState.value.mobileDrawerOpen = false;
  };

  const toggleMobileDrawer = () => {
    navigationState.value.mobileDrawerOpen =
      !navigationState.value.mobileDrawerOpen;
  };

  const toggleSubMenu = (id: string | null) => {
    navigationState.value.openedNavigationDropDownId =
      navigationState.value.openedNavigationDropDownId === id ? null : id;
  };

  const { width } = useWindowSize();
  if (!_resizeObserverRegistered.value && import.meta.client) {
    watch(width, () => {
      if (breakpoints.greaterOrEqual("md").value) {
        closeMobileDrawer();
      }
    });
    _resizeObserverRegistered.value = true;
  }

  return {
    navigationState: readonly(navigationState),
    closeMobileDrawer,
    toggleMobileDrawer,
    toggleSubMenu,
    closeAll,
  };
}
